import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

const ui = constants.colors.ui;
const { mediaQuery: breakpoints } = mediaQueryStyles;

export const buttonContainerStyles: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
};

export const closeButtonStyles: CSSObject = {
  gridArea: "closeButton",
};

const comboboxHeight = "28px";
const comboboxAccentColor = ui.core[600];
export const comboboxStyles: CSSObject = {
  display: "inline-block",
  fontSize: "12px",
  height: comboboxHeight,
  width: "100%",
  maxWidth: "300px",
  "& > div": {
    maxWidth: "100%",
  },
  "& > div:first-child": { margin: "0" },
  // customizing input field
  "& input[role='combobox']": {
    borderRadius: "8px",
    color: comboboxAccentColor,
    height: comboboxHeight,
    border: `1px solid ${ui.neutral[100]}`,
    width: "100%",
    "& + button": {
      height: comboboxHeight,
      color: comboboxAccentColor,
    },
  },
  // Ensure selected item in dropdown has high contrast
  "& [aria-selected='true'], & .selected, & .Combobox__selected": {
    color: ui.core[700], // dark blue for high contrast
    fontWeight: 700,
    background: ui.core[25],
  },
  "& ul[role='listbox']": {
    zIndex: "4",
  },
};

export const comboboxWrapperStyles: CSSObject = {
  gridArea: "combobox",
};

export const headerStyles = (hasBody: boolean): CSSObject => {
  return {
    padding: "16px",
    background: `linear-gradient(
      102deg,
      ${fullGradientColors.position0.color}1A 0%,
      ${fullGradientColors.position25.color}1A 25%,
      ${fullGradientColors.position50.color}1A 50%,
      ${fullGradientColors.position100.color}1A 100%
    )`,
    borderBottom: `1px solid ${ui.neutral[100]}`,
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit",
    borderBottomLeftRadius: hasBody ? "0px" : "inherit",
    borderBottomRightRadius: hasBody ? "0px" : "inherit",
    color: ui.neutral[600],
    display: "grid",
    alignItems: "center",
    gap: "0 10px",
    gridTemplateColumns: "auto 1fr auto",
    gridTemplateAreas: `
    'title combobox closeButton'
    `,
    [breakpoints.upTo("sm")]: {
      gridTemplateColumns: "1fr auto",
      gridTemplateRows: "35px 28px",
      gridTemplateAreas: `
      'title closeButton'
      'combobox combobox'
      `,
      paddingBlock: "12px",
    },
  };
};

export const iconStyles: CSSObject = {
  width: "23px",
  verticalAlign: "middle",
  margin: "-2px 5px 0 0",
  path: {
    stroke: "currentColor",
    strokeWidth: 0.5,
  },
};

export const titleStyles: CSSObject = {
  gridArea: "title",
  fontWeight: 700,
  verticalAlign: "middle",
};
